
<div class="container">
    <h1>Profit Calculator</h1>
    
    <div class="calculator">
        <div class="input-section">
            <h2>Input Values</h2>
            
            <div class="input-group">
                <label for="itemSold">Item Sold Price ($)</label>
                <input type="number" id="itemSold" step="0.01" min="0" [(ngModel)]="itemSold" (ngModelChange)="calculateProfit()">
            </div>
            
            <div class="input-group">
                <label for="itemCost">Item Cost ($)</label>
                <input type="number" id="itemCost" step="0.01" min="0" [(ngModel)]="itemCost" (ngModelChange)="calculateProfit()">
            </div>
            
            <div class="input-group">
                <label for="platformFee">Platform Fee (%)</label>
                <input type="number" id="platformFee" step="0.1" min="0" max="100" [(ngModel)]="platformFee" (ngModelChange)="calculateProfit()">
            </div>

            <div class="input-group">
                <label for="shippingCost">Shipping Charge ($)</label>
                <input type="number" id="shippingCharge" step="0.01" min="0" [(ngModel)]="shippingCharge" (ngModelChange)="calculateProfit()">
            </div>
            
            <div class="input-group">
                <label for="shippingCost">Shipping Cost ($)</label>
                <input type="number" id="shippingCost" step="0.01" min="0" [(ngModel)]="shippingCost" (ngModelChange)="calculateProfit()">
            </div>
            
            <div class="input-group">
                <label for="transactionFeePercent">Transaction Fee (%)</label>
                <input type="number" id="transactionFeePercent" step="0.1" min="0" max="100" [(ngModel)]="transactionFeePercent" (ngModelChange)="calculateProfit()">
            </div>
            
            <div class="input-group">
                <label for="transactionFeeCents">Transaction Fee Fixed ($)</label>
                <input type="number" id="transactionFeeCents" step="0.01" min="0" [(ngModel)]="transactionFeeCents" (ngModelChange)="calculateProfit()">
            </div>
        </div>
        
        <div class="results-section">
            <h2>Profit Breakdown</h2>

            <div class="result-item">
                <span class="result-label">Item Sold:</span>
                <span class="result-value profit" id="itemCost">{{ itemSold | currency }}</span>
            </div>

            <div class="result-item">
                <span class="result-label">Item Cost:</span>
                <span class="result-value loss" id="itemCost">{{ itemCost | currency }}</span>
            </div>

            <div class="result-item">
                <span class="result-label">Item Profit:</span>
                <span class="result-value profit" id="itemProfit">{{ itemProfit | currency }}</span>
            </div>

            <div class="result-item">
                <span class="result-label">Platform Fee:</span>
                <span class="result-value loss" id="platformFeeAmount">{{ platformFeeAmount | currency }}</span>
            </div>

            <div class="result-item">
                <span class="result-label">Transaction Fee:</span>
                <span class="result-value loss" id="transactionFeeAmount">{{ transactionFeeAmount | currency }}</span>
            </div>
            
            <div class="result-item">
                <span class="result-label">Shipping Charge:</span>
                <span class="result-value profit" id="shippingCharge">{{ shippingCharge | currency }}</span>
            </div>
            
            <div class="result-item">
                <span class="result-label">Shipping Cost:</span>
                <span class="result-value loss" id="shippingCostDisplay">{{ shippingCost | currency }}</span>
            </div>
            
            <div class="result-item">
                <span class="result-label">Total Cost:</span>
                <span class="result-value loss" id="totalCost">{{ totalCost | currency }}</span>
            </div>
            
            <div class="result-item">
                <span class="result-label">Total Profit:</span>
                <span class="result-value profit" id="totalProfit">{{ totalProfit | currency }}</span>
            </div>
        </div>
        <div class="market-section">
            <h2>{{ price.source }} Market Analysis</h2>
            
            <div class="input-row">
                <div class="input-group">
                    <label for="source">Source</label>
                    <input type="text" id="source" [(ngModel)]="price.source" readonly>
                </div>
                
                <div class="input-group">
                    <label for="averageShipping">Average Shipping ($)</label>
                    <input type="number" id="averageShipping" step="0.01" min="0" value="7.50" readonly>
                </div>
            </div>
            
            <div class="input-row">
                <div class="input-group">
                    <label for="lowestPrice">Lowest Market Price ($)</label>
                    <input type="number" id="lowestPrice" step="0.01" min="0" [(ngModel)]="price.lowest" readonly>
                </div>
                
                <div class="input-group">
                    <label for="highestPrice">Highest Market Price ($)</label>
                    <input type="number" id="highestPrice" step="0.01" min="0" [(ngModel)]="price.highest" readonly>
                </div>
            </div>
            
            <div class="market-grid">
                <div class="market-item">
                    <div class="market-item-title">Lowest Price</div>
                    <div class="market-item-value" id="lowestPriceDisplay">{{ price.lowest | currency }}</div>
                    <div class="market-item-profit" id="lowestPriceProfit">Profit: {{ ( price.lowest - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Highest Price</div>
                    <div class="market-item-value" id="highestPriceDisplay">{{ price.highest }}</div>
                    <div class="market-item-profit" id="highestPriceProfit">Profit: {{ ( price.highest - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Suggested Lowest Price</div>
                    <div class="market-item-value" id="suggestedLowestPrice">{{ price.suggestedLowest | currency }}</div>
                    <div class="market-item-profit" id="suggestedPriceProfit">Profit: {{ ( price.suggestedLowest - totalCost + shippingCharge) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Competitive Price Threshold</div>
                    <div class="market-item-value" id="competitiveThreshold">{{ price.competitive }}</div>
                    <div class="market-item-profit" id="competitivePriceProfit">Profit: {{ ( price.competitive - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Your Price</div>
                    <div class="market-item-value" id="yourPriceDisplay">{{ itemSold | currency}}</div>
                    <div class="market-item-profit" id="yourPriceProfit">Profit: {{ itemSold - totalCost + shippingCharge| currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Your Shipping</div>
                    <div class="market-item-value" id="averageShippingDisplay">{{ shippingCharge | currency }}</div>
                    <div class="market-item-profit" id="shippingDifference">Your shipping total: {{ ( shippingCharge - shippingCost ) | currency }}</div>
                </div>
            </div>

        </div>
        
        <div class="market-section" *ngIf="ebayPrices">
            <h2>{{ ebayPrices.source }} Market Analysis</h2>
            
            <div class="input-row">
                <div class="input-group">
                    <label for="source">Source</label>
                    <input type="text" id="source" [(ngModel)]="ebayPrices.source" readonly>
                </div>
                
                <div class="input-group">
                    <label for="averageShipping">Average Shipping ($)</label>
                    <input type="number" id="averageShipping" step="0.01" min="0" value="7.50" readonly>
                </div>
            </div>
            
            <div class="input-row">
                <div class="input-group">
                    <label for="lowestPrice">Lowest Market Price ($)</label>
                    <input type="number" id="lowestPrice" step="0.01" min="0" [(ngModel)]="ebayPrices.lowest" readonly>
                </div>
                
                <div class="input-group">
                    <label for="highestPrice">Highest Market Price ($)</label>
                    <input type="number" id="highestPrice" step="0.01" min="0" [(ngModel)]="ebayPrices.highest" readonly>
                </div>
            </div>
            
            <div class="market-grid">
                <div class="market-item">
                    <div class="market-item-title">Lowest Price</div>
                    <div class="market-item-value" id="lowestPriceDisplay">{{ ebayPrices.lowest | currency }}</div>
                    <div class="market-item-profit" id="lowestPriceProfit">Profit: {{ ( ebayPrices.lowest - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Highest Price</div>
                    <div class="market-item-value" id="highestPriceDisplay">{{ ebayPrices.highest }}</div>
                    <div class="market-item-profit" id="highestPriceProfit">Profit: {{ ( ebayPrices.highest - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Suggested Lowest Price</div>
                    <div class="market-item-value" id="suggestedLowestPrice">{{ ebayPrices.suggested_lower_price | currency }}</div>
                    <div class="market-item-profit" id="suggestedPriceProfit">Profit: {{ ( ebayPrices.suggested_lower_price - totalCost + shippingCharge) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Competitive Price Threshold</div>
                    <div class="market-item-value" id="competitiveThreshold">{{ ebayPrices.competitive_price_threshold }}</div>
                    <div class="market-item-profit" id="competitivePriceProfit">Profit: {{ ( ebayPrices.competitive_price_threshold - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Your Price</div>
                    <div class="market-item-value" id="yourPriceDisplay">{{ itemSold | currency}}</div>
                    <div class="market-item-profit" id="yourPriceProfit">Profit: {{ itemSold - totalCost + shippingCharge| currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Your Shipping</div>
                    <div class="market-item-value" id="averageShippingDisplay">{{ shippingCharge | currency }}</div>
                    <div class="market-item-profit" id="shippingDifference">Your shipping total: {{ ( shippingCharge - shippingCost ) | currency }}</div>
                </div>
            </div>
        </div>

        <div class="market-section" *ngIf="sapiPrice">
            <h2>{{ sapiPrice.source }} Market Analysis</h2>
            
            <div class="input-row">
                <div class="input-group">
                    <label for="source">Source</label>
                    <input type="text" id="source" [(ngModel)]="sapiPrice.source" readonly>
                </div>
                
                <div class="input-group">
                    <label for="averageShipping">Average Shipping ($)</label>
                    <input type="number" id="averageShipping" step="0.01" min="0" value="7.50" readonly>
                </div>
            </div>
            
            <div class="input-row">
                <div class="input-group">
                    <label for="lowestPrice">Lowest Market Price ($)</label>
                    <input type="number" id="lowestPrice" step="0.01" min="0" [(ngModel)]="sapiPrice.lowest" readonly>
                </div>
                
                <div class="input-group">
                    <label for="highestPrice">Highest Market Price ($)</label>
                    <input type="number" id="highestPrice" step="0.01" min="0" [(ngModel)]="sapiPrice.highest" readonly>
                </div>
            </div>
            
            <div class="market-grid">
                <div class="market-item">
                    <div class="market-item-title">Lowest Price</div>
                    <div class="market-item-value" id="lowestPriceDisplay">{{ sapiPrice.lowest | currency }}</div>
                    <div class="market-item-profit" id="lowestPriceProfit">Profit: {{ ( sapiPrice.lowest - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Highest Price</div>
                    <div class="market-item-value" id="highestPriceDisplay">{{ sapiPrice.highest }}</div>
                    <div class="market-item-profit" id="highestPriceProfit">Profit: {{ ( sapiPrice.highest - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Suggested Lowest Price</div>
                    <div class="market-item-value" id="suggestedLowestPrice">{{ sapiPrice.suggested_lower_price | currency }}</div>
                    <div class="market-item-profit" id="suggestedPriceProfit">Profit: {{ ( sapiPrice.suggested_lower_price - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Competitive Price Threshold</div>
                    <div class="market-item-value" id="competitiveThreshold">{{ sapiPrice.competitive_price_threshold }}</div>
                    <div class="market-item-profit" id="competitivePriceProfit">Profit: {{ ( sapiPrice.competitive_price_threshold - totalCost + shippingCharge ) | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Your Price</div>
                    <div class="market-item-value" id="yourPriceDisplay">{{ itemSold | currency}}</div>
                    <div class="market-item-profit" id="yourPriceProfit">Profit: {{ itemSold - totalCost + shippingCharge | currency }}</div>
                </div>
                
                <div class="market-item">
                    <div class="market-item-title">Your Shipping</div>
                    <div class="market-item-value" id="averageShippingDisplay">{{ shippingCharge | currency }}</div>
                    <div class="market-item-profit" id="shippingDifference">Your shipping: {{ ( shippingCharge - shippingCost ) | currency }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="navigation">
        <button mat-raised-button color="primary" (click)="backBtn()">Back</button>
    </div>
</div>